import CONSTANTS from "../../Utils/constant";
import {
  RESET_BOOK_RESPONSE,
  RESET_FORM_TYPE,
  SET_TPA_DETAILS,
  SET_APPOINTMENT_DATE_TYPE,
  SET_MOBILE_TYPE,
  SET_EMAIL_TYPE,
  SET_APPOINTMENT_TIME_TYPE,
  SET_IS_MODAL_OPEN_TYPE,
  SET_ERROR_TYPE,
  SET_LANGUAGE_TYPE,
  SET_IS_INSTANT_TYPE,
  SET_CALL_MODE_TYPE,
  SET_VH_SLOTS_TYPE,
  SET_VH_MIN_DATE_TYPE,
  SET_VH_MAX_DATE_TYPE
} from "./types";

const INSTANT_ALLOWED_TPA = "VH";

const initialFormObj = {
  appointmentDate: null,
  mobile: "",
  email: "",
  appointmentTime: {
    hour: "09",
    minute: "00",
    meridiem: "AM",
  },
  language: "",
  vhSlots: [],
  vhMinDate: null,
  vhMaxDate: null,
  callMode: CONSTANTS?.SCHEDULE,
  isInstantMode: false,
  errors: {},
};

const initialState = {
  tpaDetails: null,
  isModalOpen: false,
  ...initialFormObj,
};

const teleUwReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_TPA_DETAILS:
      return {
        ...state,
        tpaDetails: payload?.value,
        isInstantMode: payload?.value === INSTANT_ALLOWED_TPA,
      };
    case SET_EMAIL_TYPE:
      return {
        ...state,
        email: payload?.value,
      };
    case SET_MOBILE_TYPE:
      return {
        ...state,
        mobile: payload?.value,
      };
    case SET_LANGUAGE_TYPE:
      return {
        ...state,
        language: payload?.value,
      };
    case SET_CALL_MODE_TYPE:
      return {
        ...state,
        callMode: payload?.value,
      };
    case SET_VH_SLOTS_TYPE:
      return {
        ...state,
        vhSlots: payload?.value,
      };
    case SET_VH_MIN_DATE_TYPE:
      return {
        ...state,
        vhMinDate: payload?.value,
      };
    case SET_VH_MAX_DATE_TYPE:
      return {
        ...state,
        vhMaxDate: payload?.value,
      };
    case SET_IS_INSTANT_TYPE:
      return {
        ...state,
        isInstantMode: payload?.value,
      };
    case SET_APPOINTMENT_DATE_TYPE:
      return {
        ...state,
        appointmentDate: payload?.value,
      };
    case SET_APPOINTMENT_TIME_TYPE:
      return {
        ...state,
        appointmentTime: payload?.value,
      };
    case SET_IS_MODAL_OPEN_TYPE:
      return {
        ...state,
        isModalOpen: payload?.value,
      };
    case SET_ERROR_TYPE:
      return {
        ...state,
        errors: { ...state[payload?.memberId]?.errors, ...payload?.value },
      };
    case RESET_FORM_TYPE:
      const { tpaDetails, isModalOpen } = state || {};
      return {
        ...state,
        tpaDetails,
        isModalOpen,
        ...initialFormObj,
      };
    case RESET_BOOK_RESPONSE:
      return { ...initialState };
    default:
      return state;
  }
};

export default teleUwReducer;
